import React from 'react';
import useMediaQuery, { XLBREAK, LBREAK, MBREAK, XSBREAK } from './useMediaQuery';

export const XSMediaQuery: React.SFC<React.PropsWithChildren<any>> = (props) => {
    const xls = useMediaQuery(XLBREAK);
    const l = useMediaQuery(LBREAK);
    const m = useMediaQuery(MBREAK);
    const xs = useMediaQuery(XSBREAK);

    return (
        <React.Fragment>
            {!xls && !l && ! m && xs && props.children}
        </React.Fragment>
    )
}